import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Box,
    Chip
} from "@mui/material";

import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import AutoFixHighOutlinedIcon from '@mui/icons-material/AutoFixHighOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import SyncProblemOutlinedIcon from '@mui/icons-material/SyncProblemOutlined';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined';
import HistoryIcon from '@mui/icons-material/History';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

const AIAuditGovernance = () => {
    const navigate = useNavigate();

    const timelineData = [
        { name: '10 AM', uv: 400, pv: 240, amt: 240 },
        { name: '11 AM', uv: 300, pv: 139, amt: 221 },
        { name: '12 PM', uv: 200, pv: 980, amt: 229 },
        { name: '1 PM', uv: 278, pv: 390, amt: 200 },
        { name: '2 PM', uv: 189, pv: 480, amt: 218 },
        { name: '3 PM', uv: 239, pv: 380, amt: 250 },
        { name: '4 PM', uv: 349, pv: 430, amt: 210 },
    ];

    const [auditData] = useState([
        {
            id: 1,
            datetime: "Apr 6, 11:14 AM",
            feature: "Discord",
            featureColor: "default",
            details: "Alert created Vendor Risk Surge",
            adminUser: "Farouk",
            resultType: "incident",
            resultText: "Incident",
        },
        {
            id: 2,
            datetime: "Apr 5, 04:12 PM",
            feature: "Dispute AI",
            featureColor: "default",
            details: "Threshold edited for autopilot Confidence 70% -> 75%",
            adminUser: "Zakaria",
            resultType: "success",
            resultText: "Success",
        },
        {
            id: 3,
            datetime: "Apr 4, 08:15 PM",
            feature: "Pricing AI",
            featureColor: "default",
            details: "Switched Model Gemini -> ChatGPT",
            adminUser: "Zakaria",
            resultType: "success",
            resultText: "Success",
        },
        {
            id: 4,
            datetime: "Apr 4, 07:40 PM",
            feature: "Budget Increase",
            featureColor: "warning",
            details: "Quota MozoYalo Limit 200k -> 210k",
            adminUser: "Anika",
            resultType: "warning",
            resultText: "Override",
        },
        {
            id: 5,
            datetime: "Apr 3, 07:40 PM",
            feature: "Campaign Suggestion",
            featureColor: "default",
            details: "Budget Change Price +20% Reason: Budget Cut",
            adminUser: "-",
            resultType: "override",
            resultText: "Override",
        },
        {
            id: 6,
            datetime: "Apr 3, 03:30 PM",
            feature: "Campaign Suggestion",
            featureColor: "default",
            details: "Budget Change Price +20% Reason: Budget Cut",
            adminUser: "-",
            resultType: "override",
            resultText: "Override",
        },
        {
            id: 7,
            datetime: "Apr 3, 05:52 PM",
            feature: "Campaign Suggestion",
            featureColor: "default",
            details: "Budget Change Price +20% Reason: Budget Cut Id: 34249",
            adminUser: "-",
            resultType: "override",
            resultText: "Override",
        },
    ]);

    return (
        <>
            <div className="main_title">
                <h1>AI Audit & Governance Log</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Audit & Governance Log
                </p>
            </div>

            <div className="stats_boxes gap_m mb_20">
                {/* CARD 1 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            Last 24 Hours
                            <p>System Overview</p>
                        </h2>
                        <figure className="sucess">
                            <AccessTimeOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <div>
                            <PeopleOutlineIcon fontSize="small" /> <span>5 Total Events</span>
                        </div>
                        <div>
                            <DescriptionOutlinedIcon fontSize="small" /> <span>3 Incidents</span>
                        </div>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            85
                            <p>Admin Overrides</p>
                        </h2>
                        <figure className="warning">
                            <AdminPanelSettingsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <div>
                            <WarningAmberOutlinedIcon fontSize="small" /> <span>High 99% MTTR</span>
                        </div>
                        <div>
                            <HistoryIcon fontSize="small" /> <span>Log 23/185</span>
                        </div>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            19
                            <p>Success Rate</p>
                        </h2>
                        <figure className="warning">
                            <BugReportOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight positive">
                        <div>
                            <AutoFixHighOutlinedIcon fontSize="small" /> <span>Gemini: +3.32%</span>
                        </div>
                        <div>
                            <ArrowDownwardOutlinedIcon fontSize="small" /> <span>High -2.6%</span>
                        </div>
                    </div>
                </div>

                {/* CARD 4 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            93
                            <p>Incidents</p>
                        </h2>
                        <figure className="sucess">
                            <SyncProblemOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight negative">
                        <div>
                            <GppBadOutlinedIcon fontSize="small" /> <span>High Close threats</span>
                        </div>
                        <div>
                            <ReportGmailerrorredOutlinedIcon fontSize="small" /> <span>High Critical</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="table_flex">
                <div className="lt">
                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    Audit Log

                                </h3>
                            </div>
                            <div className="right_s">
                                <Button className="btn btn_primary outline" startIcon={<FileDownloadOutlinedIcon />}>
                                    Export Log
                                </Button>
                            </div>
                        </div>

                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Date/Time</TableCell>
                                        <TableCell>Feature</TableCell>
                                        <TableCell>Change Details</TableCell>
                                        <TableCell>Admin/User</TableCell>
                                        <TableCell>Result</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {auditData.map((row) => (
                                        <TableRow hover key={row.id}>
                                            <TableCell>{row.datetime}</TableCell>
                                            <TableCell>
                                                {row.feature && (
                                                    <Chip
                                                        size="small"
                                                        label={row.feature}
                                                        variant="outlined"
                                                        color={row.featureColor === 'warning' ? 'warning' : 'default'}
                                                        sx={{ borderRadius: '6px' }}
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>{row.details}</TableCell>
                                            <TableCell>{row.adminUser}</TableCell>
                                            <TableCell>
                                                <Box display="flex" alignItems="center" gap={1}>
                                                    {row.resultType === 'incident' && <ErrorOutlineIcon fontSize="small" color="error" />}
                                                    {row.resultType === 'success' && <CheckCircleOutlineIcon fontSize="small" color="success" />}
                                                    {row.resultType === 'warning' && <CheckCircleOutlineIcon fontSize="small" color="warning" />}
                                                    {row.resultType === 'override' && <ErrorOutlineIcon fontSize="small" color="warning" />}
                                                    <span className={`status_text ${row.resultType}`}>
                                                        {row.resultText}
                                                    </span>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell sx={{ color: '#999' }}>Apr 3, 01:45 PM</TableCell>
                                        <TableCell colSpan={3} sx={{ color: '#999' }}>IGaudit treasonobited mask 8x Rockxing scopepements</TableCell>
                                        <TableCell>
                                            <Box display="flex" justifyContent="flex-end">
                                                <Button size="small" startIcon={<LockOutlinedIcon />} endIcon={<KeyboardArrowDownIcon />} variant="outlined" color="inherit" sx={{ color: '#666', borderColor: '#e0e0e0', textTransform: 'none' }}>
                                                    Save Version Diff
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    {/* AUDIT STATISTICS TABLE */}
                    {/* <div className="cards table_card mt_20">
                        <div className="table_header">
                            <div className="left_s">
                                <h3 className="flex_center gap_s" style={{ margin: 0 }}>
                                    Audit Statistics<span style={{ fontSize: '13px', color: '#999', fontWeight: 'normal' }}>(Last 30 Days)</span>
                                </h3>
                            </div>
                        </div>

                        <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} px={3} py={2} borderBottom={1} borderColor="divider" flexWrap="wrap">
                            <Box display="flex" gap={1} alignItems="center">
                                <span className="status_label success">
                                    <CheckCircleOutlineIcon fontSize="small" /> Success <strong>45%</strong>
                                </span>
                                <span className="status_label warning">
                                    <CheckCircleOutlineIcon fontSize="small" /> Override <strong>25%</strong>
                                </span>
                                <span className="status_label error">
                                    <ErrorOutlineIcon fontSize="small" /> Incident <strong>15%</strong>
                                </span>
                                <span className="text_muted mx-2">&gt;</span>
                            </Box>



                            <Box display="flex" gap={2} alignItems="center">

                                <Button size="small" startIcon={<SyncProblemOutlinedIcon fontSize="small" />} variant="text" color="inherit">
                                    Retry
                                </Button>
                            </Box>
                        </Box>

                        <TableContainer className="table_container">
                            <Table>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell width="20%">Apr 3, 03:32 PM</TableCell>
                                        <TableCell width="15%">
                                            <span className="badge_light">
                                                Success <span className="text_muted small">4.9%</span>
                                            </span>
                                        </TableCell>
                                        <TableCell width="30%">Suggested price change</TableCell>
                                        <TableCell width="15%">Dr. Shaunak</TableCell>
                                        <TableCell width="15%">
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <CheckCircleOutlineIcon fontSize="small" className="text_success" />
                                                <b className="text_success">Success</b>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right" width="5%">
                                            <Button size="small" startIcon={<DescriptionOutlinedIcon fontSize="small" />} variant="text" color="inherit" className="btn_icon_text">merik</Button>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow hover>
                                        <TableCell>Apr 3, 03:32 PM</TableCell>
                                        <TableCell>
                                            <span className="badge_light">
                                                Success <span className="text_muted small">4.9%</span>
                                            </span>
                                        </TableCell>
                                        <TableCell>
                                            Suggested price change Price: <b>+20%</b> Reason:
                                        </TableCell>
                                        <TableCell>Sohail</TableCell>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <CheckCircleOutlineIcon fontSize="small" className="text_warning" />
                                                <b className="text_warning">Override</b>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="right">
                                            <Button size="small" startIcon={<DescriptionOutlinedIcon fontSize="small" />} variant="text" color="inherit" className="btn_icon_text">Imrie</Button>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div> */}
                </div>
                {/* <div className="rt">
                    <div className="cards">
                        <div className="table_header">
                            <div className="left_s">
                                <h3>Change History Timeline</h3>
                            </div>
                        </div>

                        <div className="timeline_chart_area">
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={timelineData} barCategoryGap={2}>
                                    <XAxis dataKey="name" tick={{ fontSize: 10, fill: '#999' }} axisLine={false} tickLine={false} interval="preserveStartEnd" minTickGap={20} />
                                    <Tooltip cursor={{ fill: '#f5f5f5' }} />
                                    <Bar dataKey="uv" stackId="a" radius={[2, 2, 0, 0]} />
                                    <Bar dataKey="pv" stackId="a" radius={[2, 2, 0, 0]} />
                                    <Bar dataKey="amt" stackId="a" radius={[2, 2, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>

                        <div className="timeline_stats_row">
                            <div className="stat_item text_success">
                                <CheckCircleOutlineIcon fontSize="small" /> <b>23.83%</b>
                            </div>
                            <div className="stat_item text_muted">
                                <span className="rotate_icon">↳</span> <b>15%</b>
                            </div>
                            <div className="stat_item text_warning">
                                <ErrorOutlineIcon fontSize="small" color="warning" /> <b>15%</b>
                            </div>
                            <div className="stat_item text_muted">
                                <PeopleOutlineIcon fontSize="small" /> <b>5</b>
                            </div>
                            <div className="stat_item flex_center">
                                <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 9.5C1 9.5 3 6.5 5 8.5C7 10.5 8 11.5 10 9.5C12 7.5 13 4.5 15 6.5C17 8.5 19 4.5 20 2C21 -0.5 23 3 23 3" stroke="#8A92A6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M11 5L15 9L19 4" stroke="#DC5E45" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className="config_rollback_card cards">
                        <h3>Configuration Rollback</h3>
                        <div className="rollback_meta">
                            Updated by Zakaria - Apr 5, 2024, 04:12 PM
                        </div>
                        <div className="rollback_list">
                            <div className="rollback_item">
                                <span className="item_label">Confidence Threshold</span>
                                <span className="item_value">70% <span className="arrow">→</span> 75%</span>
                            </div>
                            <div className="rollback_item">
                                <span className="item_label">Risk Classification</span>
                                <span className="item_value">Override Threshold <span className="arrow">{">"}</span></span>
                            </div>
                            <div className="rollback_item">
                                <span className="item_label">Segmentation A/B Testing</span>
                                <span className="item_value">5,0000 <span className="arrow">→</span> 100,000</span>
                            </div>
                        </div>
                        <div className="rollback_action">
                            <button className="btn_rollback">
                                <HistoryIcon fontSize="small" /> Rollback to Apr 4, 03:10 PM
                            </button>
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
};

export default AIAuditGovernance;
